import { checkEmail, checkPhone, checkField } from "./validators";
import debounce from "./debounce";

class FormValidator {
  constructor() {
    this.isFormProcessing = false;
    this.formValues = null;
    this.formWrapper = document.querySelector("#form-wrapper");
    this.messageSent = document.querySelector("#message-sent");
    this.sendAgainButton = document.querySelector("#send-again");
    this.spinner = document.querySelector(".contact-spinner");

    this.form = document.querySelector("#contact-form");

    this.fullname = document.querySelector("#fullname");
    this.email = document.querySelector("#email");
    this.phone = document.querySelector("#phone");
    this.message = document.querySelector("#message");
    this.recaptchaToken = document.querySelector("#recaptcha-token");

    if (this.form) {
      this.form.addEventListener("submit", this.onFormSubmit.bind(this));
      this.form.addEventListener("input", debounce(this.onInput.bind(this)));
      this.sendAgainButton.addEventListener("click", this.showForm.bind(this));
    }
  }

  onFormSubmit(e) {
    // prevent the form from submitting
    e.preventDefault();

    if (this.isFormProcessing) {
      return;
    }

    // validate forms
    let isNameValid = checkField(this.fullname),
      isMessageValid = checkField(this.message),
      isPhoneValid = checkPhone(this.phone),
      isEmailAddressValid = checkEmail(this.email),
      isRecaptchaTokenValid = checkField(this.recaptchaToken);

    let isFormValid =
      isNameValid &&
      isEmailAddressValid &&
      isMessageValid &&
      isPhoneValid &&
      isRecaptchaTokenValid;

    // submit to the server if the form is valid
    if (isFormValid) {
      this.isFormProcessing = true;
      this.spinner.style.display = "block";
      this.formValues = {
        fullname: this.fullname.value,
        phone: this.phone.value,
        email: this.email.value,
        message: this.message.value,
        recaptchaToken: this.recaptchaToken.value,
      };
      this.sendEmail();
    }
  }

  onInput(e) {
    if (e.target.id === "fullname") {
      checkField(this.fullname);
    } else if (e.target.id === "phone") {
      checkPhone(this.phone);
    } else if (e.target.id === "email") {
      checkEmail(this.email);
    } else if (e.target.id === "message") {
      checkField(this.message);
    }
  }

  async sendEmail() {
    const endpoint = contact_form.url;
    const nonce = contact_form.nonce;
    const formData = new FormData();
    const serializedData = new URLSearchParams(this.formValues).toString();

    formData.append("action", "contact_form");
    formData.append("nonce", nonce);
    formData.append("data", serializedData);

    const response = await fetch(endpoint, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && data.success) {
      this.hideForm();
    }
  }

  showForm() {
    this.formWrapper.style.display = "block";
    this.messageSent.style.display = "none";
    this.isFormProcessing = false;
    this.spinner.style.display = "none";
  }

  hideForm() {
    this.formWrapper.style.display = "none";
    this.messageSent.style.display = "block";
    this.isFormProcessing = false;
    this.spinner.style.display = "none";
    this.resetForm();
  }

  resetForm() {
    this.formValues = null;
    this.fullname.value = "";
    this.email.value = "";
    this.phone.value = "";
    this.message.value = "";
    this.recaptchaToken.value = "";
    grecaptcha.reset();
  }
}

export default FormValidator;
